import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import variables from '../theme/variables';
import { useUHF } from '../hooks/useUHF';

const useStyles = createUseStyles(
    {
        wrap: {
            position: 'absolute',
            height: variables.msftHeaderHeight,
            width: '100%',
            zIndex: 10000,
            boxShadow: '0px 0px 50px rgba(0, 0, 0, 0.25)',
            transition: 'all 0.6s ease-out',
        },
    },
    { name: 'MSFTHeader' }
);

export default function MSFTHeader() {
    const classes = useStyles();
    const { headerHtml, cssIncludes } = useUHF();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (cssIncludes && cssIncludes.length) {
            setTimeout(() => {
                setVisible(true);
            }, 1000);
        }
    }, [cssIncludes]);

    return (
        <div
            className={classes.wrap}
            style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(-50px)',
            }}
        >
            <div dangerouslySetInnerHTML={{ __html: headerHtml }}></div>
        </div>
    );
}
